import {
  Button,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Typography,
  styled,
} from "@mui/material";

import { createStyleSheet } from "../utils/styles";
import { t } from "i18next";

const ErrorDialogUx = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ErrorDialog = (props: {
  title?: string;
  message: string;
  open: boolean;
  onClose: () => void;
}) => {
  const { title, message, open, onClose } = props;

  return (
    <ErrorDialogUx open={open} onClose={onClose}>
      <DialogTitle>{title || t("common:error")}</DialogTitle>
      <DialogContentText sx={styles.dialogContent}>
        <Typography>{message}</Typography>
      </DialogContentText>
      <DialogActions sx={styles.dialogButtonContainer}>
        <Button autoFocus onClick={onClose}>
          {t("common:close")}
        </Button>
      </DialogActions>
    </ErrorDialogUx>
  );
};

const styles = createStyleSheet({
  dialogContent: {
    mx: 3,
  },
  dialogButtonContainer: {
    m: 1,
  },
});

export default ErrorDialog;
